export default __webpack_public_path__ + "static/media/4.4856d28c.mp3";